import queryString from "query-string";

import { getBaseStore } from "@utils/configuration/aem";

import createApiModule from "@redux/create-api-module";

import { StoresMapper } from "../stores.mapper";
import {
    $StorelocatorModuleName,
    LocalizedStoresSearchParams,
} from "./storeLocator.types";

const { actions, constants } = createApiModule(
    $StorelocatorModuleName,
    (params: LocalizedStoresSearchParams) => {
        const fullParams = {
            includeProductAvailability: true,
            ...params,
            filterInactive: true,
        };

        return `/storeservice/${getBaseStore()}/localized/stores?${queryString.stringify(
            fullParams,
        )}`;
    },
    {
        mergeParams: false,
        mapper: StoresMapper,
    },
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
export const APIStatus = constants;
